import React, { useState, useEffect } from "react";

const ImageSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = ["/blog1.jpg", "/blog4.jpg", "/blog2.jpg", "/blog3.jpg"];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="group relative p-1 my-8 max-w-4xl mx-auto">
      {/* Gradient Background */}
      <div className="absolute -inset-1 bg-gradient-to-r from-yellow-300 to-yellow-500 rounded-lg blur opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>

      {/* Content Container */}
      <div className="relative bg-slate-900 rounded-lg p-4 overflow-hidden">
        {/* Image Slider */}
        <div className="relative h-[400px] w-full overflow-hidden rounded-lg">
          {images.map((img, index) => (
            <div
              key={index}
              className={`absolute w-full h-full transition-transform duration-500 ease-in-out ${
                index === currentIndex ? "translate-x-0" : "translate-x-full"
              }`}
              style={{
                transform: `translateX(${100 * (index - currentIndex)}%)`,
              }}
            >
              <img
                src={img}
                alt={`Slide ${index + 1}`}
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          ))}
        </div>

        {/* Dot Navigation */}
        <div className="flex justify-center mt-6 gap-2">
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentIndex
                  ? "bg-yellow-400 w-8"
                  : "bg-yellow-600 hover:bg-yellow-500"
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        {/* Call-to-Action Section */}
        <div className="relative mt-8 ">
          <div className="absolute -inset-0.5  rounded-lg blur opacity-50"></div>
          <div className="relative bg-slate-800 p-8 rounded-lg transform transition-all duration-300 ease-in-out">
            <h3 className="text-xl text-yellow-500 font-semibold  text-center mb-4">
               Hooked on Tech, Inspired to Blog ... 
            </h3>
            <p className="text-green-500 font-mono text-center leading-relaxed">
              Welcome to my corner of the web! Explore the latest blogs, ideas,
              and technology trends. Join our growing community and stay updated
              on the latest in tech.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageSlider;
